<template>
  <div class="full flex flex-col lg:flex-row">
    <div class="h-half-mobile-full-desk lg:w-1/3 order-2 lg:order-1">
      <div class="p-brand h-full overflow-scroll scrolling-touch">
        <div class="brand-text sticky-back-btn">
          <router-link to="/">
            👈🏿 <span class="pl-1">Back</span>
          </router-link>
        </div>
        <div class="brand-title">
          Snow + Blooming
        </div>
        <div class="brand-text">
          Christmas Yayyyyyyy
        </div>
        <div class="brand-hr"></div>

        <div ref="controlRoot" class="controls"></div>
        <div ref="controlBloom" class="controls"></div>
        <div ref="controlDots" class="controls"></div>
        <div ref="controlSnow" class="controls"></div>
      </div>
    </div>
    <StarEffect @root="setupRoot($event)" @bloomer="setupBloomer($event)" @dots="setupDots($event)" @snow="setupSnow($event)" class="h-half-mobile-full-desk lg:w-2/3  order-1 lg:order-2"></StarEffect>
  </div>
</template>

<script>
import { O3DVue } from '../../Core/O3DVue.js'
import { setNum, setBtn, UIControls } from '../UIControls/UIControls.js'
// import { setNum, setColor, setBtn, UIControls } from '../UIControls/UIControls.js'
export default {
  mixins: [
    O3DVue
  ],
  data () {
    return {
      gui1: false,
      gui2: false,
      gui3: false,
      gui4: false,
      settings: false
    }
  },
  beforeDestroy () {
    if (this.gui1) {
      this.gui1.destroy()
    }
    if (this.gui2) {
      this.gui2.destroy()
    }
    if (this.gui3) {
      this.gui3.destroy()
    }
    if (this.gui4) {
      this.gui4.destroy()
    }
  },
  methods: {
    setupRoot (root) {
      let gui = this.gui4 = new UIControls({ last: this.gui4, mounter: this.$refs.controlRoot })

      let folder = gui.addFolder('Canvas')
      setBtn(folder, 'Take Photo', root.makePNG)

      folder.open()
    },
    setupBloomer (bloom) {
      let gui = this.gui3 = new UIControls({ last: this.gui3, mounter: this.$refs.controlBloom })

      let folder = gui.addFolder('Bloom')
      setNum(folder, bloom.params, 'bloomThreshold', 'Threshold', 0, 1, 0.001)
      setNum(folder, bloom.params, 'bloomStrength', 'Strength', 0, 10, 0.001)
      setNum(folder, bloom.params, 'bloomRadius', 'Radius', 0, 3, 0.001)

      folder.open()
    },
    setupSnow (snow) {
      let gui = this.gui2 = new UIControls({ last: this.gui2, mounter: this.$refs.controlSnow })

      let folder = gui.addFolder('Snow')
      setNum(folder, snow, 'fallSpeed', 'Fall Speed', 0, 50, 0.01)
      setNum(folder, snow.material.uniforms.swingSpeed, 'value', 'Swing Speed', 0, 10, 0.01)
      setNum(folder, snow.material.uniforms.swingFreq, 'value', 'Swing Frequency', 0, 1, 0.01)

      folder.open()
    },
    setupDots (dots) {
      let gui = this.gui1 = new UIControls({ last: this.gui1, mounter: this.$refs.controlDots })

      let folder = gui.addFolder('Bloom')
      setNum(folder, dots, 'blinkSpeed', 'Blink Speed', 0, 3, 0.01)
      setNum(folder, dots, 'fallSpeed', 'Fall Speed', 0, 50, 0.01)

      folder.open()

      // setBtn(gui, 'Download Image', dots.makePNG)
      // setColor(gui, dots.bgColor, 'Background')

      // dots.clusters.forEach((cluster, cIdx) => {
      //   let folder = gui.addFolder('Points Group' + (cIdx + 1))

      //   setColor(folder, cluster.dots.material.color, 'Dot color')

      //   setNum(folder, cluster, 'dotScale', 'Dot size', 0, 2, 0.01, () => {
      //   })

      //   setNum(folder, cluster, 'groupScale', 'Group Size', 0, 2, 0.01, () => {
      //   })

      //   setNum(folder, cluster, 'count', 'Dot Counts', 0, 128, 1, () => {
      //   })

      //   setBtn(folder, 'Radomize', cluster.randomize)

      //   folder.open()
      // })
    }
  },
  mounted () {
  }
}
</script>

<style>

</style>